import React, {useState, getGlobal} from 'reactn';
import { Form, Input , Button, Checkbox, Select, Radio, Row, Col } from 'antd';
import { useFirestore } from 'reactfire';

// import { Form, Input, Button, Layout ,  } from 'antd';

// import { Button, Modal, Skeleton, Form, Input, , Table, message, Popconfirm } from 'antd';

const { TextArea } = Input;

const SingleMedicine = (props) => {

    const layout = {
        labelCol: { span: 0 },
        wrapperCol: { span: 24 },
    };
    const { Option } = Select;

    const [state, setState] = useState(props.medicinename.medicine);
    // const [frmData, setFrmData] = useState({
        
    // });
    const firestore = useFirestore();
    const [form] = Form.useForm();
    const [loadingBtn, setLoadingBtn] = useState(false);

    const onNewRecord = (values) => {
        setLoadingBtn(true);
        values.medicine = state;

        Object.keys(values).forEach(key => values[key] === undefined && delete values[key]);
        console.log('this is from test', values)
        firestore.collection('Treatment_records').add({
            patient: firestore.collection("patients").doc(getGlobal().patientID),
            appointment: firestore.collection("appointments").doc(getGlobal().appointmentId),
            appointment_id: getGlobal().appointmentId,
            medicine_info: values,
            timestamp: new Date(),
          }).then(() => {
            props.recAdded();
            setLoadingBtn(false);
        });


    }
    const onFinishFailed = (values) => {
        console.log(values);
    }

    const showDosageVal = ()=> {
        if (state.type === "Drops") {
            return (
                <>
                <Option value="ایک قطرے">ایک قطرے</Option>
                <Option value="دو قطرے">دو قطرے</Option>
                <Option value="تین قطرے">تین قطرے</Option>
                <Option value="چار قطرے">چار قطرے</Option>
                <Option value="پانچ قطرے">پانچ قطرے</Option>
                </>
            );
        } else if (state.type === "Tablet") {
            return (
                <>
                <Option value="آدھی گولی">آدھی گولی</Option>
                <Option value="ایک گولی">ایک گولی</Option>
                <Option value="دو گولیاں">دو گولیاں</Option>
                <Option value="تین گولیاں">تین گولیاں</Option>
                <Option value="چار گولیاں">چار گولیاں</Option>
                <Option value="پانچ گولیاں">پانچ گولیاں</Option>
                </>
            );
        } else if (state.type === "capsule") {
            return (
                <>
                <Option value="ایک کیپسول">ایک کیپسول</Option>
                <Option value="دو کیپسول">دو کیپسول</Option>
                <Option value="تین کیپسول">تین کیپسول</Option>
                <Option value="چار کیپسول">چار کیپسول</Option>
                <Option value="پانچ کیپسول">پانچ کیپسول</Option>
                </>
            );
        } else if (state.type === "Syrup") {
            return (
                <>
                <Option value="آدھا چاۓ کا چمچ">آدھا چاۓ کا چمچ</Option>
                <Option value="ایک چاۓ کا چمچ">ایک چاۓ کا چمچ</Option>
                <Option value="ڈیڑھ چاۓ کا چمچ">ڈیڑھ چاۓ کا چمچ</Option>
                <Option value="دو چاۓ کے چمچ">دو چاۓ کے چمچ</Option>
                <Option value="تین چاۓ کے چمچ">تین چاۓ کے چمچ</Option>
                <Option value="چار چاۓ کے چمچ">چار چاۓ کے چمچ</Option>
                <Option value="پانچ چاۓ کے چمچ">پانچ چاۓ کے چمچ</Option>
                </>
            );
        } else if (state.type === "Injection") {
            return (
                <>
                <Option value="ایک ٹیکے">ایک ٹیکے</Option>
                <Option value="دو ٹیکے">دو ٹیکے</Option>
                <Option value="تین ٹیکے">تین ٹیکے</Option>
                <Option value="چار ٹیکے">چار ٹیکے</Option>
                <Option value="پانچ ٹیکے">پانچ ٹیکے</Option>
                </>
            );
        } else if (state.type === "Tube") {
            return (
                <>
                <Option value="ایک بار">ایک بار</Option>
                <Option value="دو بار">دو بار</Option>
                <Option value="تین بار">تین بار</Option>
                <Option value="چار بار">چار بار</Option>
                <Option value="پانچ بار">پانچ بار</Option>
                </>
            );
        } else if (state.type === "Spray") {
            return (
                <>
                <Option value="ایک بار">ایک بار</Option>
                <Option value="دو بار">دو بار</Option>
                <Option value="تین بار">تین بار</Option>
                <Option value="چار بار">چار بار</Option>
                <Option value="پانچ بار">پانچ بار</Option>
                </>
            );
        } else {
            return (
                <>
                <Option value="ایک خوراک">ایک خوراک</Option>
                <Option value="دو خوراک">دو خوراک</Option>
                <Option value="تین خوراک">تین خوراک</Option>
                <Option value="چار خوراک">چار خوراک</Option>
                <Option value="پانچ خوراک">پانچ خوراک</Option>
                </>
            ); 
        }
    }

    return (
        <li>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <h4>{`${state.medicine_name} (${state.formula})  - ${state.weight} - ${state.type}`}</h4>
            </div>

            <Form
                {...layout}
                layout="vertical"
                name="basic"
                form={form}
                initialValues={{ remember: true }}
                onFinish={onNewRecord}
                initialValues={{
                    ['note']: props.medicinename.note,
                    ['frequency']: props.medicinename.frequency,
                    ['dosage']: props.medicinename.dosage,
                    ['dosage_in_ml']: props.medicinename.dosage_in_ml,
                    ['duration']: props.medicinename.duration,
                    ['when']: props.medicinename.when,
                }}
                onFinishFailed={onFinishFailed}>

                <Row gutter={12}>
                    <Col span={24}>
                        <Form.Item
                            label="Frequency"
                            name="frequency"
                            rules={[{ required: true, message: 'Please add Medicine Frequency' }]}>
                            <Checkbox.Group className='img_btns' style={{ width: '100%' }}>
                                <Checkbox value="صبح">صبح</Checkbox>
                                <Checkbox value="دوپہر">دوپہر</Checkbox>
                                <Checkbox value="شام">شام</Checkbox>
                                <Checkbox value="رات">رات</Checkbox>
                                <Checkbox value="حسب ضرورت">حسب ضرورت</Checkbox>
                            </Checkbox.Group>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="When to take"
                            name="when">
                            <Radio.Group className='img_btns' buttonStyle="solid" size="large">
                                <Radio.Button value={'کھانے سے پہلے'}>کھانے سے پہلے</Radio.Button>
                                <Radio.Button value={'کھانے کے دوران'}>کھانے کے دوران</Radio.Button>
                                <Radio.Button value={'کھانے کے بعد'}>کھانے کے بعد</Radio.Button>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={12}>
                    <Col span={8}>
                        <Form.Item
                            label="Dosage"
                            name="dosage"
                            rules={[{ message: 'Please add Medicine Dosage' }]}
                        >
                            <Select placeholder= "منتخب کریں" >
                                {showDosageVal()}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            label="Dosage in ml"
                            name="dosage_in_ml"
                            rules={[{ message: 'Please add Medicine Dosage in ml' }]}
                        >
                            <Input size="medium" addonAfter="ml" />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            label="Duration"
                            name="duration"
                            rules={[{ message: 'Please add Medicine Duration' }]}
                        >
                            <Select defaultValue="ایک دن" >
                                <Option value="ایک دن">ایک دن</Option>
                                <Option value="دو دن">دو دن</Option>
                                <Option value="تین دن">تین دن</Option>
                                <Option value="چار دن">چار دن</Option>
                                <Option value="پانچ دن">پانچ دن</Option>
                                <Option value="چھ دن">چھ دن</Option>
                                <Option value="ایک ہفتہ">ایک ہفتہ</Option>
                                <Option value="دس دن">دس دن</Option>
                                <Option value="دو ہفتے">دو ہفتے</Option>
                                <Option value="تین ہفتے">تین ہفتے</Option>
                                <Option value="ایک مہینہ">ایک مہینہ</Option>
                                <Option value="دو ماہ">دو ماہ</Option>
                                <Option value="جاری رکھیں">جاری رکھیں</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item
                    label="Note"
                    name="note"
                >
                    <Input size="large" />
                </Form.Item>

       
                <Button type="primary" loading={loadingBtn} htmlType="submit">
                    Add
                </Button>


          </Form>
{/* 
          <Button type="primary" style={{position: 'absolute', right: '15px', bottom: '15px'}} htmlType="submit">
            Add to Favorites
          </Button> */}

            
        </li>
    );
}

export default SingleMedicine;
